


















import {Vue, Component } from 'vue-property-decorator';
import {mapGetters} from 'vuex';

@Component({
  name: 'PageNotFound',
  computed: {
    ...mapGetters(['translations']),
  },
})
export default class PageNotFound extends Vue {}
